import { render } from "./OnboardingWizard.vue?vue&type=template&id=8367ed90&scoped=true&ts=true"
import script from "./OnboardingWizard.vue?vue&type=script&lang=ts"
export * from "./OnboardingWizard.vue?vue&type=script&lang=ts"

import "./OnboardingWizard.vue?vue&type=style&index=0&id=8367ed90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8367ed90"]])

export default __exports__